const systemRouters = {
  path: "/system",
  component: () => import("@/views/layout"),
  name: "system",
  meta: { public: true },
  children: [
    {
      path: "message",
      component: () => import("@/views/System/MessageCenter"),
      name: "system-message",
      meta: { hideNav: true }
    },
    {
      path: "personal",
      component: () => import("@/views/System/Personal/Layout"),
      name: "system-personal",
      meta: { hideNav: true },
      redirect: "personal/setting",
      children: [
        {
          path: "setting",
          component: () => import("@/views/System/Personal/Setting"),
          name: "system-personal-setting",
          meta: { hideNav: true }
        },
        {
          path: "password",
          component: () => import("@/views/System/Personal/Password"),
          name: "system-personal-password",
          meta: { phideNav: true }
        },
        {
          path: "companies",
          component: () => import("@/views/System/Personal/Companies"),
          name: "system-personal-companies",
          meta: { hideNav: true }
        }
      ]
    }
  ]
}

export default systemRouters
